/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface PaginationModel {
  count: number;
  current_page: number;
  next_page: number | null;
  total: number;
  total_pages: number;
  results: any[][];
}

export interface PersonDto {
  profile_picture: string | null;
  last_name: string;
  given_name: string;
  known_as: string | null;
  user_id: string;
  relation_id: string;
}

export interface ChannelMessageDto {
  created_at: string;
  updated_at: string | null;
  text: string;
  sender: PersonDto | null;
  deleted_at: string | null;
}

export interface ChannelMemberDto {
  role: ChannelMemberDtoRoleEnum;
  user: PersonDto;
}

export interface ChannelDto {
  id: string;
  unread_count: number;
  last_user_message: ChannelMessageDto | null;
  last_read_message_id: string | null;
  member_count: number;
  message_count: number;
  creator_id: string;
  last_channel_message: ChannelMessageDto | null;
  members: ChannelMemberDto[];
}

export interface ThreadDto {
  school_id: string;
  root_entity_id: string;
  root_entity_type: ThreadDtoRootEntityTypeEnum;
  id: string;
  name: string | null;
  channel: ChannelDto | null;
  status: ThreadDtoStatusEnum;
  parents: PersonDto[];
  children: PersonDto[];
  invited_staff: PersonDto[];
  spectators: PersonDto[];
  creator: string;
}

export interface ChannelTokenDto {
  token: string;
}

export interface ChannelConnectionDto {
  connection_id: string;
  token: string;
  created_at: number;
  expires_at: number;
}

export interface RootEntityDto {
  id: string;
  title: string;
  type: RootEntityDtoTypeEnum;
  has_attachments: boolean;
  creator_id: string;
}

export interface UnreadThreadDto {
  channel_id: string;
  last_read_message_id: string | null;
  unread_count: number;
  message_count: number;
  last_user_message: ChannelMessageDto | null;
  last_channel_message: ChannelMessageDto | null;
  thread_id: string;
  root_entity: RootEntityDto;
}

export type EntityThreadMapping = object;

export type RootEntityMapping = object;

export interface UnreadThreadsDto {
  /** @example {"root_entity_type":{"root_entity_id":[{"thread_id":"uuid","channel_id":"uuid","unread_count":5,"message_count":10,"last_read_message_id":"uuid","last_user_message":{"id":"message-uuid","text":"This is the last user message","created_at":"2023-05-10T15:30:00Z","sender":{"id":"user-uuid","first_name":"John","last_name":"Doe","avatar_url":"https://example.com/avatar.jpg"},"deleted_at":null},"last_channel_message":{"id":"uuid","text":"This is the last channel message","created_at":"2023-05-10T16:00:00Z","sender":{"id":"uuid","first_name":"Jane","last_name":"Smith","avatar_url":"https://example.com/avatar2.jpg"},"deleted_at":null},"root_entity":{"id":"uuid","title":"Important Message","type":"message","has_attachments":false,"creator_id":"uuid"}}]}} */
  unread_threads: Record<string, Record<string, UnreadThreadDto[]>>;
}

export interface ThreadLastActivityInput {
  school_id: string;
  root_entity_type: ThreadLastActivityInputRootEntityTypeEnum;
  root_entity_ids: string[];
}

export interface LastActivityData {
  last_reply_at: string;
  last_reply_text: string;
  last_reply_sender: PersonDto;
}

export interface ThreadLastActivityDto {
  data: Record<string, LastActivityData>;
}

export interface ThreadAggregateInput {
  school_id: string;
  root_entity_id: string;
  root_entity_type: ThreadAggregateInputRootEntityTypeEnum;
  include: ThreadAggregateInputIncludeEnum[];
}

export interface ThreadAggregateDto {
  /** @example {"uuid-root-entity-id":{"root_entity_status":"active"}} */
  data: Record<string, any>;
}

export interface CreateThreadChannelInput {
  school_id: string;
}

export interface UpdateThreadMembersInput {
  school_id: string;
  new_members?: PersonDto[];
  spectators?: PersonDto[];
}

export interface EntityContextDto {
  school_id: string;
  root_entity_id: string;
  root_entity_type: EntityContextDtoRootEntityTypeEnum;
}

export interface UpdateThreadsInput {
  school_id: string;
  root_entity_id: string;
  root_entity_type: UpdateThreadsInputRootEntityTypeEnum;
  thread_ids: string[];
  status: UpdateThreadsInputStatusEnum;
}

export enum ChannelMemberDtoRoleEnum {
  ChannelSpectator = "channel_spectator",
  ChannelMember = "channel_member",
  ChannelOwner = "channel_owner",
}

export enum ThreadDtoRootEntityTypeEnum {
  Message = "message",
}

export enum ThreadDtoStatusEnum {
  Active = "active",
  Archived = "archived",
}

export enum RootEntityDtoTypeEnum {
  Message = "message",
}

export enum ThreadLastActivityInputRootEntityTypeEnum {
  Message = "message",
}

export enum ThreadAggregateInputRootEntityTypeEnum {
  Message = "message",
}

export enum ThreadAggregateInputIncludeEnum {
  RootEntityStatus = "root_entity_status",
}

export enum EntityContextDtoRootEntityTypeEnum {
  Message = "message",
}

export enum UpdateThreadsInputRootEntityTypeEnum {
  Message = "message",
}

export enum UpdateThreadsInputStatusEnum {
  Active = "active",
  Archived = "archived",
}

export enum ThreadControllerGetThreadsParamsRootEntityTypeEnum {
  Message = "message",
}

export enum ThreadControllerGetUnreadChannelsParamsRootEntityTypeEnum {
  Message = "message",
}
